import { UPDATE_BROADCAST_SETTINGS } from 'actions/Types';
import { shouldHaveFeature } from '@studio/feature.flags';

function settings(state = {}, action) {
  if (
    action.type === UPDATE_BROADCAST_SETTINGS &&
    !shouldHaveFeature('studio.requirePresenterAuth')
  ) {
    return {
      ...state,
      ...action.payload
    };
  }
  return state;
}

export default settings;
